import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import ExcelJS from "exceljs";
import { utils, writeFile } from "xlsx";
import {
  Tab,
  Tabs,
  Form,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
  Row,
  Col,
  Container,
  ListGroup,
} from "react-bootstrap";
import AdminApi from "../../../api/admin";
import WaitListCoupleApi from "../../../api/WaitListCoupleApi";
import AuthApi from "../../../api/authApi";
import { toast } from "react-toastify";
import CustomDataTable from "../../../components/CustomDataTable";
import Helpers from "../../../components/Helpers";
import DeleteModel from "../../../components/DeleteModel";
import { Cookies } from "react-cookie";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import RetreatApi from "../../../api/retreatApi";
import RetreatRoastApi from "../../../api/retreatRoasterApi";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import ImagePlaceHolder from "../../../assets/images/image-placeholder.png";
import DirectoryApi from "../../../api/directoryApi";
import ProgramApi from "../../../api/programApi";
import Profile from "../../../assets/images/couple-default.png";
import fbIcon from "../../../assets/images/facebook-logo.webp";
import QrDummy from "../../../assets/images/qrScanner.jpg";
import AlertDelete from "../../../components/AlertDelete";
import ConfirmationAuditModal from "../../../components/ConfirmationAuditModal";
import moment from "moment-timezone";
import DirectoryModel from "./DirectoryModel";
import ProgramModel from "./ProgramModel";
import { formatParishOptionLabel } from "../../../utils/parishLabels";
import { formatCoupleOptionLabel } from "../../../utils/coupleLabels";
import FileUploadModal from "../../../components/FileUploadModal";
import AlertModal from "../../../components/AlertModel";
import RetreatStatusModal from "../../../components/RetreatStatusModal";
import CreateRetreatSubAdmin from "../../../components/createRetreatSubAdmin";
import corruptedImg from "../../../assets/images/corrupted-img.png";
import uploadRetreat from "../../../assets/images/uploadRetreat.png";
import RegistrationPasswordSendModal from "../../../components/RegistrationPasswordSendModal";
import "../../../assets/css/ManageRetreatModern.css";
import { useTrainingGuide } from "../../../components/AdminTrainingGuide";

const LANGUAGE_FILTER_OPTIONS = [
  { value: "", label: "All Languages" },
  { value: "english", label: "English" },
  { value: "spanish", label: "Spanish" },
];

const normalizeLanguageFilter = (value) => {
  const text = String(value || "").trim();
  if (!text || text.toLowerCase() === "not set") return "";
  const match = LANGUAGE_FILTER_OPTIONS.find(
    (item) => item.value && item.value.toLowerCase() === text.toLowerCase(),
  );
  return match ? match.value : text;
};

const readLanguageFilter = (location) => {
  const params = new URLSearchParams(location?.search || "");
  const fromQuery = params.get("language");
  const fromState = location?.state?.language;
  return normalizeLanguageFilter(fromQuery || fromState || "");
};

const ManageRetreat = () => {
  const locationData = useLocation();
  const initialLanguageFilter = readLanguageFilter(locationData);
  const [showRegModal, setShowREgModal] = useState(false);
  const [total, setTotal] = useState(20);
  const [searchKey, setSearchKey] = useState(""); //for searching
  const [show, setShow] = useState(false);
  const [icon_id, setIcon_id] = useState("");
  let cookies = new Cookies();
  let userData = cookies.get("LoveStrongUser") || null;
  const [perishDataList, setPerishDataList] = useState([]);
  const [allRetreatData, setAllRetreatData] = useState([]);
  const [LoadData, setLoadData] = useState(false);
  const [directory, setDirectory] = useState([]);
  const [program, setProgram] = useState([]);
  const [retreatDetail, setRetreatDetail] = useState([]);
  const [deleteList, setDeleteList] = useState(null);
  const [contactData, setContactData] = useState(false);
  const [confirmedData, setConfirmedData] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [allSelected, setAllSelected] = useState(false);
  const [editBox, setEditBox] = useState(false);
  const [createRetAdmin, setCreateRetAdmin] = useState(false);
  const [allCoupleMails, setAllCoupleMails] = useState([]);
  const [allCoupleData, setAllCoupleData] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [removeAccessModal, setRemoveAccessModal] = useState(false);
  const [selectedRetreats, setSelectedRetreats] = useState([]);
  const [showingRetreats, setShowingRetreats] = useState(false);
  const [fileType, setFileType] = useState("");
  const [existingFileUrl, setExistingFileUrl] = useState("");
  const [uploadModalTitle, setUploadModalTitle] = useState("");
  const [parishValue, setParishValue] = useState("");
  const [languageFilter, setLanguageFilter] = useState(initialLanguageFilter);
  const languageFilterRef = useRef(initialLanguageFilter);
  const [alertData, setAlertData] = useState([]);
  const [clearSelectionTrigger, setClearSelectionTrigger] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [ediUserIdClicked, setEdiUserIdClicked] = useState("");
  const [password, setPassword] = useState("");
  const [showFreeze, setShowFreeze] = useState(false);
  const [showPasswordMailModal, setShowPasswordMailModal] = useState(false);
  let adminApi = new AdminApi();
  let retreatApi = new RetreatApi();
  let authApi = new AuthApi();
  let waitListCoupleApi = new WaitListCoupleApi();

  let directoryApi = new DirectoryApi();
  let programApi = new ProgramApi();
  let navigate = useNavigate();
  const training = useTrainingGuide();
  const searchTimer = useRef(null);

  const [data, setData] = useState({
    id: "",
    retreatment: "",
    title: "",
    parish: "",
    language: "",
    location: "",
    schedule: [],
    image1: "",
    image2: "",
    heading: "",
    mission_statement:
      "The mission of the LOVESTRONG Marriage Ministry is to support, strengthen, and nurture the Christ-centered bond between married couples in our parish and community.",
    description: "",
  });
  const [timeDate, setTimeDate] = useState({
    date: "",
    from: "00:00",
    to: "00:00",
  });
  const [newTitle, setNewTitle] = useState({
    parish: "",
    language: "",
    location: "",
  });

  useEffect(() => {
    if (locationData?.state?.parishValue) {
      setParishValue(String(locationData.state.parishValue));
      getAllRetreats(
        1,
        20,
        null,
        {},
        false,
        "",
        null,
        locationData?.state?.parishValue,
      );
    } else {
      getAllRetreats();
    }
    getAllCouples();
    getPerishList();

  }, []);

  useEffect(() => {
    const nextLanguage = readLanguageFilter(locationData);
    if (nextLanguage !== languageFilterRef.current) {
      languageFilterRef.current = nextLanguage;
      setLanguageFilter(nextLanguage);
    }
    if (locationData?.state?.parishValue) {
      setParishValue(String(locationData.state.parishValue));
      getAllRetreats(
        1,
        20,
        null,
        {},
        false,
        "",
        null,
        locationData?.state?.parishValue,
      );
    } else if (nextLanguage && nextLanguage !== languageFilter) {
      getAllRetreats();
    }
  }, [locationData]);

  useEffect(() => {
    return () => {
      if (searchTimer.current) clearTimeout(searchTimer.current);
    };
  }, []);

  useEffect(() => {
    getPassword();
  }, [showPasswordMailModal]);

  const handleUploadProgram = (retreat) => {
    setSelectedRowId(retreat.id);
    setUploadModalTitle(retreat.title);
    setFileType("programFile");
    setShowUploadModal(true);
    setExistingFileUrl(retreat.programFile);
  };

  const handleUploadDirectory = (retreat) => {
    setSelectedRowId(retreat.id);
    setUploadModalTitle(retreat.title);
    setFileType("directoryFile");
    setShowUploadModal(true);
    setExistingFileUrl(retreat.directoryFile);
  };

  const renderFileActions = (row, { fileUrl, onUpload, uploadTitle, viewTitle, iconClass }) => {
    const frozen = row?.freeze === "FREEZE";
    return (
      <div className={`mr-file-actions${frozen ? " editRetreatDisabled" : ""}`}>
        <a
          href="#"
          title={uploadTitle}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!frozen) onUpload(row);
          }}
        >
          <i className={`mdi ${iconClass}`}></i>
        </a>
        {fileUrl ? (
          <a
            className="mr-file-download"
            title={viewTitle}
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            <i className="mdi mdi-download"></i>
          </a>
        ) : null}
      </div>
    );
  };

  const handleUploadModalClose = () => {
    setShowUploadModal(false);
    setSelectedRowId(null);
    setFileType("");
    setExistingFileUrl("");
    setUploadModalTitle("");
  };

  const handleUploadSuccess = () => {
    if (showingRetreats === true) {
      getAllRetreats(1, 20, null, {}, false, "", userData?.id);
    } else {
      getAllRetreats();
    }
  };

  const handleDeleteFile = () => {
    setExistingFileUrl(null);
    if (showingRetreats === true) {
      getAllRetreats(1, 20, null, {}, false, "", userData?.id);
    } else {
      getAllRetreats();
    }
  };

  const getPassword = async () => {
    await retreatApi
      .getPassword()
      .then((res) => {
        if (res.success) {
          setPassword(res?.data?.password);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const getAllRetreats = async (
    pageNo = 1,
    size = 20,
    searchKeyword = null,
    sortBy = {},
    loadCount = false,
    coupleId,
    committeeId = "",
    parishValue = null,
  ) => {
    setAllRetreatData([]);
    setLoadData(true);
    let d = {};
    if (pageNo && size) {
      d.pageNo = pageNo;
      d.size = size;
    }
    if (searchKeyword !== null) {
      d.searchKeyword = searchKeyword;
    } else {
      d.searchKeyword = searchKey;
    }
    if (sortBy.sortColumn) {
      d.sortBy = sortBy;
    } else {
      const now = new Date();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      d.upcomingFirst = true;
      d.today = `${now.getFullYear()}-${month}-${day}`;
    }
    d.export = false;
    d.coupleId = coupleId;
    d.committeeId = committeeId;
    d.parishValue = parishValue || null;
    if (languageFilterRef.current) {
      d.languageFilter = languageFilterRef.current;
    }
    if (userData?.committeeMember === true && userData?.userRole !== "ADMIN") {
      d.committeeId = userData.id;
    }
    if (userData?.access === true && userData?.userRole !== "ADMIN") {
      d.accessId = userData.id;
    }
    await retreatApi
      .getAllRetreats(d)
      .then((res) => {
        if (res.success) {
          let totalRecords = res.totalRecords ? res.totalRecords : 0;
          setTotal(totalRecords);
          const parsedData = res.data.map((item) => {
            const { confirmation, schedule, ...rest } = item;
            const parsedSchedule = schedule ? JSON.parse(schedule) : [];
            const parsedConfirmation = confirmation
              ? JSON.parse(confirmation)
              : [];
            return {
              ...rest,
              confirmation: parsedConfirmation,
              schedule: parsedSchedule.map((entry) => ({
                date: new Date(entry.date),
                from: entry.from,
                to: entry.to,
              })),
            };
          });
          setLoadData(false);
          if (parishValue && parishValue !== null) {
            const retreatIds = parsedData.map((retreat) => retreat.id);
            setSelectedRetreats(retreatIds);
          }
          setAllRetreatData(parsedData);
        } else {
          setLoadData(false);
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        setLoadData(false);
        toast.error(error);
      });
  };

  const getPerishList = async () => {
    await authApi
      .getPerishList()
      .then((response) => {
        const sortedList = response.data.sort((a, b) =>
          a.parish.localeCompare(b.parish),
        );
        setPerishDataList(sortedList);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const tempDeleteDataList = async () => {
    await retreatApi
      .tempDeleteDataList()
      .then((response) => {
        setDeleteList(response.data);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const deleteRetreat = async () => {
    await retreatApi
      .tempDeleteRetreat({ id: icon_id })
      .then(async (res) => {
        if (res.success) {
          setShow(false);
          setIcon_id("");
          toast.success(res.msg);
          if (showingRetreats === true) {
            getAllRetreats(1, 20, null, {}, false, "", userData?.id);
          } else {
            getAllRetreats();
          }

        } else {
          toast.error(res.msg);
          if (showingRetreats === true) {
            getAllRetreats(1, 20, null, {}, false, "", userData?.id);
          } else {
            getAllRetreats();
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const restoreRetreat = async (id) => {
    await retreatApi
      .restoreRetreat({ id: id })
      .then(async (res) => {
        if (res.success) {
          toast.success(res.msg);
          tempDeleteDataList();
        } else {
          toast.error(res.msg);
          tempDeleteDataList();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const permanentDeleteRetreat = async (id) => {
    await retreatApi
      .permanentDeleteRetreat({ id: id })
      .then(async (res) => {
        if (res.success) {
          toast.success(res.msg);
          tempDeleteDataList();
        } else {
          toast.error(res.msg);
          tempDeleteDataList();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const SearchData = (event) => {
    const key = event.target.value;
    setSearchKey(key);
    if (searchTimer.current) clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => {
      const activeParish = parishValue || locationData?.state?.parishValue || null;
      if (showingRetreats === true) {
        getAllRetreats(1, 20, key, {}, false, "", userData?.id, activeParish);
      } else {
        getAllRetreats(1, 20, key, {}, false, "", null, activeParish);
      }
    }, 350);
  };

  const clearfield = () => {
    setData({
      id: "",
      retreatment: "",
      title: "",
      parish: "",
      language: "",
      location: "",
      schedule: [],
      image1: "",
      image2: "",
      heading: "",
      mission_statement:
        "The mission of the LOVESTRONG Marriage Ministry is to support, strengthen, and nurture the Christ-centered bond between married couples in our parish and community.",
      description: "",
    });
    setNewTitle({
      parish: "",
      language: "",
      location: "",
    });
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip">{props}</Tooltip>
  );

  const customTooltip = (props) => (
    <Tooltip id="button-tooltip" className="custom-tooltip">
      {props}
    </Tooltip>
  );

  const handleShow1 = (row) => {
    setShowFreeze(true);
    let d = { ...alertData };
    d.value = row.freeze;
    d.retreatId = row.id;
    d.title = row.title;
    d.language = row.language;
    d.location = row.location;
    d.parishName = row.parishName;
    setAlertData(d);
  };

  const handleClose2 = () => {
    setShowFreeze(false);
    setAlertData([]);
  };

  const retreatFreeze = () => {
    retreatApi
      .retreatFreeze(alertData)
      .then((res) => {
        handleClose2();
        if (showingRetreats === true) {
          getAllRetreats(1, 20, null, {}, false, "", userData?.id);
        } else {
          getAllRetreats();
        }

        toast.success(res.msg);
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const handleShowStatus = (row) => {
    setShowStatus(true);
    setAlertData(row);
  };

  const handleCloseStatus = () => {
    setShowStatus(false);
    setAlertData([]);
    setEditBox(false);
  };

  const exportWaitListCouples = async (userData) => {
    try {
      const response = await waitListCoupleApi.waitListCouplesData({
        retreatId: userData.id,
      });

      if (!response?.success || !response.data) {
        toast.error(response?.msg || "Failed to fetch waitlist data");
        return;
      }

      if (!response.data || response.data.length === 0) {
        toast.info("Data is empty");
        return;
      }
      const exportData = response.data;

      const formattedData = exportData.map((el) => ({
        "His First Name": el.hisFirstName || "",
        "His Last Name": el.hisLastName || "",
        "His Email": el.hisEmail || "",
        "His Mobile": el.hisMobile || "",
        "Her First Name": el.herFirstName || "",
        "Her Last Name": el.herLastName || "",
        "Her Email": el.herEmail || "",
        "Her Mobile": el.herMobile || "",
        Address: el.address || "",
        City: el.city || "",
        State: el.state || "",
        Zip: el.zip || "",
        Parish: el.parish?.parish || "",
        "Anniversary Date": el.anniversary_date
          ? moment(el.anniversary_date).format("MM-DD-YYYY")
          : "",
      }));

      const wb = utils.book_new();
      const ws = utils.json_to_sheet(formattedData);
      utils.book_append_sheet(wb, ws, "WaitList Couples");

      const fileName = `WaitList_Couples_${moment().format(
        "MMM-DD-YYYY",
      )}.xlsx`;

      writeFile(wb, fileName);
    } catch (error) {
      console.error("❌ Error exporting WaitList couples:", error);
      toast.error("Something went wrong while exporting WaitList couples");
    }
  };

  const retreatChangeStatus = (reason = "") => {
    const payload = {
      alertData: {
        ...alertData,
        inactiveReason: reason,
      },
      userData: userData,
      editBox,
    };
    retreatApi
      .retreatChangeStatus(payload)
      .then((res) => {
        handleCloseStatus();

        if (showingRetreats === true) {
          getAllRetreats(1, 20, null, {}, false, "", userData?.id);
        } else {
          getAllRetreats();
        }


        toast.success(res.message);
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  function formatLabel(firstName, lastName, email) {
    let namePart = "";
    if (lastName) namePart += lastName;
    if (firstName) namePart += (lastName ? ", " : "") + firstName;
    return namePart ? `${namePart} - ${email}` : email;
  }

  const getAllCouples = async () => {
    await adminApi
      .allCouples()
      .then(async (res) => {
        if (res.success) {
          let allcoupleList = [];
          let allMailcoupleList = [];
          res.data &&
            res.data.forEach((item) => {
              if (item.hisFirstName || item.hisLastName || item.herFirstName) {
                const emails = [item.hisEmail, item.herEmail]
                  .filter(Boolean)
                  .join(" & ");

                allcoupleList.push({
                  label: formatCoupleOptionLabel(item),
                  value: item.id,
                });
              }

              if (item.hisEmail) {
                allMailcoupleList.push({
                  label: formatLabel(
                    item.hisFirstName,
                    item.hisLastName,
                    item.hisEmail,
                  ),
                  value: item.id,
                });
              }

              if (item.herEmail) {
                allMailcoupleList.push({
                  label: formatLabel(
                    item.herFirstName,
                    item.herLastName,
                    item.herEmail,
                  ),
                  value: item.id,
                });
              }
            });

          const sort = allcoupleList.sort((a, b) =>
            a.label.localeCompare(b.label),
          );
          setAllCoupleData(sort);
          await adminApi.outerUsers().then((res) => {
            if (res.success) {
              res.data &&
                res.data.forEach((item) => {
                  if (item.email) {
                    allMailcoupleList.push({
                      label: item.email,
                      value: item.id,
                    });
                  }
                });
              setAllCoupleMails(allMailcoupleList);
            }
          });
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const editRetreat = async (id) => {
    await retreatApi
      .getRetreatDetail({ id: id })
      .then((res) => {
        if (res.success) {
          const { schedule, ...rest } = res.data[0];
          const parsedSchedule = schedule ? JSON.parse(schedule) : [];
          let parsedData = {
            ...rest,
            schedule: parsedSchedule.map((entry) => ({
              date: new Date(entry.date),
              from: entry.from,
              to: entry.to,
            })),
            parish: res.data[0].parishId,
          };
          let myparish = perishDataList.find(
            (i) => i.id === parsedData.parishId,
          );
          if (myparish) {
            parsedData.myparish = myparish;
          }
          setData(parsedData);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // ─── UPDATED: accept row so we can set ediUserIdClicked ───────────────────
  const subAdminPopUP = (row) => {
    if (row && row.id) {
      setEdiUserIdClicked(row.id);
      editRetreat(row.id);
      setCreateRetAdmin(true);
    } else {
      toast.error("Please select a retreat first.");
    }
  };

  // Sub-admins can delete any admin entry including themselves — no role-block
  const handlerAccessRmvShow = (item) => {
    setEditIndex(item);
    setRemoveAccessModal(true);
  };

  const handleAccessRmvClose = () => {
    setRemoveAccessModal(false);
    setEditIndex(null);
  };

  const removeAccessFromRetreat = () => {
    retreatApi
      .removeAccessFromRetreat({
        remove_access_mail: editIndex,
        retreatId: ediUserIdClicked,
      })
      .then((res) => {
        toast.success(res.msg);
        // Refresh data state so the modal list updates immediately
        editRetreat(ediUserIdClicked);
        handleAccessRmvClose();
      })
      .catch((error) => {
        console.error(error);
        toast.error("An error occurred while removing the administrator.");
      });
  };

  const columns = [
    ...(userData && userData.userRole === "ADMIN"
      ? [
          {
            id: "Active/Deactivate",
            name: (
              <OverlayTrigger
                placement="bottom"
                overlay={customTooltip(
                  "Retreat Registration stops if Deactivate",
                )}
              >
                <span>Active/Deactivate</span>
              </OverlayTrigger>
            ),
            cell: (row) => {
              return (
                <>
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip(
                      row.status === "ACTIVE" ? "ACTIVE" : "INACTIVE",
                    )}
                  >
                    <Form.Check
                      className={`switchSize  ${
                        row.status === "ACTIVE"
                          ? "toggle-on-status"
                          : "toggle-off-status"
                      }`}
                      type="checkBox"
                      name="status"
                      value={row.status}
                      checked={row.status === "ACTIVE"}
                      onChange={(e) => {
                        handleShowStatus(row);
                      }}
                      id="status"
                    />
                  </OverlayTrigger>

                  {row.status === "INACTIVE" ? (
                    <i
                      onClick={() => {
                        setEditBox(true);
                        handleShowStatus(row);
                      }}
                      className={`mdi mdi-pencil text-lg mt-2 font-size`}
                      title="Edit Deactivate Reason"
                      style={{ marginLeft: "15px" }}
                    ></i>
                  ) : null}

                  {row.waitList === true ? (
                    <span
                      className="mt-2 waitlistcouple"
                      onClick={() => exportWaitListCouples(row)}
                    >
                      WL
                    </span>
                  ) : null}
                </>
              );
            },
            reorder: true,
            width: "150px",
            conditionalCellStyles: [
              {
                when: (row) => {
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  const dateFrom = new Date(row.dateFrom);
                  dateFrom.setHours(0, 0, 0, 0);
                  const dateTo = new Date(row.dateTo);
                  dateTo.setHours(0, 0, 0, 0);
                  return dateFrom >= today || dateTo >= today;
                },
                style: {
                  backgroundColor: "#e7f6ea",
                },
              },
            ],
          },
          {
            id: "action",
            name: "Action",
            button: true,
            cell: (row) => (
              <>
                {" "}
                {row && row.freeze === "FREEZE" ? (
                  <span className="font-size action-icons">
                    <i
                      className={`mdi mdi-pencil-box text-lg ${
                        row && row.freeze === "FREEZE"
                          ? "editRetreatDisabled"
                          : "editRetreatButton"
                      } font-size`}
                      title="Edit"
                    ></i>
                  </span>
                ) : (
                  <Link
                    to={`/create-retreat/${row.id}`}
                    className="font-size action-icons"
                  >
                    <i
                      className={`mdi mdi-pencil-box text-lg ${
                        row && row.freeze === "FREEZE"
                          ? "editRetreatDisabled"
                          : "editRetreatButton"
                      } font-size`}
                      title="Edit"
                    ></i>
                  </Link>
                )}
                <button
                  disabled={row && row.freeze === "FREEZE" ? true : false}
                  className="font-size action-icons"
                  onClick={() => handleShow(row)}
                >
                  <i
                    className={`mdi mdi-delete-forever text-md ${
                      row && row.freeze === "FREEZE"
                        ? "deleteRetreatDisabled"
                        : "deleteRetreatButton"
                    } font-size`}
                    title="Delete"
                  ></i>
                </button>
              </>
            ),
            reorder: true,
            width: "120px",
            conditionalCellStyles: [
              {
                when: (row) => {
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  const dateFrom = new Date(row.dateFrom);
                  dateFrom.setHours(0, 0, 0, 0);
                  const dateTo = new Date(row.dateTo);
                  dateTo.setHours(0, 0, 0, 0);
                  return dateFrom >= today || dateTo >= today;
                },
                style: {
                  backgroundColor: "#e7f6ea",
                },
              },
            ],
          },
          {
            id: "Freeze",
            name: (
              <OverlayTrigger
                placement="bottom"
                overlay={customTooltip("Edit/Delete not allowed")}
              >
                <span>Freeze</span>
              </OverlayTrigger>
            ),
            selector: (row) => {
              return (
                <Form.Check
                  className={`switchSize ${
                    row.freeze === "FREEZE" ? "toggle-on" : "toggle-off"
                  }`}
                  type="switch"
                  name="freeze"
                  value={row.freeze}
                  checked={row.freeze === "FREEZE" ? true : false}
                  onChange={(e) => {
                    handleShow1(row);
                  }}
                  id="freeze"
                />
              );
            },
            reorder: true,
            width: "80px",
            conditionalCellStyles: [
              {
                when: (row) => {
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  const dateFrom = new Date(row.dateFrom);
                  dateFrom.setHours(0, 0, 0, 0);
                  const dateTo = new Date(row.dateTo);
                  dateTo.setHours(0, 0, 0, 0);
                  return dateFrom >= today || dateTo >= today;
                },
                style: {
                  backgroundColor: "#e7f6ea",
                },
              },
            ],
          },
          {
            id: "registrationLink",
            name: "Registration Link",
            button: true,
            cell: (row) => (
              <a
                href={`/registration-retreat/${row.id}`} // ✅ FIX HERE
                target="_blank"
                rel="noopener noreferrer"
                className="roasterKey"
              >
                <img
                  src={row.image1 || uploadRetreat}
                  className="column-rowImage"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = corruptedImg;
                  }}
                />
              </a>
            ),
            reorder: true,
            width: "120px",
            conditionalCellStyles: [
              {
                when: (row) => {
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);

                  const dateFrom = new Date(row.dateFrom);
                  dateFrom.setHours(0, 0, 0, 0);

                  const dateTo = new Date(row.dateTo);
                  dateTo.setHours(0, 0, 0, 0);

                  return dateFrom >= today || dateTo >= today;
                },
                style: { backgroundColor: "#e7f6ea" },
              },
            ],
          },
        ]
      : []),

    ...(userData &&
    userData.userRole !== "ADMIN" &&
    (userData.committeeMember === true || userData.access === true) &&
    Boolean(retreatDetail.retreatCloseStatus) === 0
      ? [
          {
            id: "action",
            name: "Action",
            button: true,
            cell: (row) => (
              <>
                {" "}
                {row && row.freeze === "FREEZE" ? (
                  <span className="font-size action-icons">
                    <i
                      className={`mdi mdi-pencil-box text-lg ${
                        row && row.freeze === "FREEZE"
                          ? "editRetreatDisabled"
                          : "editRetreatButton"
                      } font-size`}
                      title="Edit"
                    ></i>
                  </span>
                ) : (
                  <Link
                    to={`/create-retreat/${row.id}`}
                    className="font-size action-icons"
                  >
                    <i
                      className={`mdi mdi-pencil-box text-lg ${
                        row && row.freeze === "FREEZE"
                          ? "editRetreatDisabled"
                          : "editRetreatButton"
                      } font-size`}
                      title="Edit"
                    ></i>
                  </Link>
                )}
              </>
            ),
            reorder: true,
            width: "150px",
            conditionalCellStyles: [
              {
                when: (row) => {
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  const dateFrom = new Date(row.dateFrom);
                  dateFrom.setHours(0, 0, 0, 0);
                  const dateTo = new Date(row.dateTo);
                  dateTo.setHours(0, 0, 0, 0);
                  return dateFrom >= today || dateTo >= today;
                },
                style: { backgroundColor: "#e7f6ea" },
              },
            ],
          },
        ]
      : []),

    ...(userData &&
    userData.userRole !== "ADMIN" &&
    (userData.committeeMember === true || userData.access === true)
      ? [
          {
            id: "registrationLink",
            name: "Registration Link",
            button: true,
            cell: (row) => (
              <a
                href={`/registration-retreat/${row.id}`} // ✅ FIX HERE
                target="_blank"
                rel="noopener noreferrer"
                className="roasterKey"
              >
                <img
                  src={row.image1 || uploadRetreat}
                  className="column-rowImage"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = corruptedImg;
                  }}
                />
              </a>
            ),
            reorder: true,
            width: "120px",
            conditionalCellStyles: [
              {
                when: (row) => {
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);

                  const dateFrom = new Date(row.dateFrom);
                  dateFrom.setHours(0, 0, 0, 0);

                  const dateTo = new Date(row.dateTo);
                  dateTo.setHours(0, 0, 0, 0);

                  return dateFrom >= today || dateTo >= today;
                },
                style: { backgroundColor: "#e7f6ea" },
              },
            ],
          },
        ]
      : []),

    {
      id: "retreatId",
      name: "Retreat Id",
      selector: (row) => row?.id,
      sortable: true,
      reorder: true,
      width: "110px",
      style: { cursor: "text" },
      conditionalCellStyles: [
        {
          when: (row) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dateFrom = new Date(row.dateFrom);
            dateFrom.setHours(0, 0, 0, 0);
            const dateTo = new Date(row.dateTo);
            dateTo.setHours(0, 0, 0, 0);
            return dateFrom >= today || dateTo >= today;
          },
          style: { backgroundColor: "#e7f6ea" },
        },
      ],
    },
    {
      id: "title",
      name: "Retreat Title",
      selector: (row) => {
        const formatDateRange = (from, to) => {
          if (moment(from).isSame(to, "day")) {
            return `${moment(from).tz("America/New_York").format("MMM D, YYYY")}`;
          } else if (moment(from).isSame(to, "month")) {
            return `${moment(from).tz("America/New_York").format("MMM D")} - ${moment(to).tz("America/New_York").format("D")}, ${moment(from).tz("America/New_York").format("YYYY")}`;
          } else {
            return `${moment(from).tz("America/New_York").format("MMM D")} - ${moment(to).tz("America/New_York").format("MMM D")}, ${moment(from).tz("America/New_York").format("YYYY")}`;
          }
        };

        const displayDate =
          row.dateFrom && row.dateTo
            ? formatDateRange(row.dateFrom, row.dateTo)
            : null;
        const retreatTitle = `${row?.parishName || ""}${
          row.language
            ? ` (${row.language[0].toUpperCase()}${row.language.slice(1)})`
            : ""
        }${
          row.location
            ? ` ${row.location[0].toUpperCase()}${row.location.slice(1)}`
            : ""
        }`.trim();

        return (
          <>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              popperConfig={{ strategy: "fixed" }}
              overlay={renderTooltip(retreatTitle || "Retreat")}
            >
              <a
                href=""
                className="mr-retreat-link"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(`/retreatRoster?retreatId=${row.id}`);
                }}
              >
                <div className="mr-retreat-name">{retreatTitle}</div>
              </a>
            </OverlayTrigger>
            {displayDate && (
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip(displayDate)}
              >
                <span className="mr-retreat-date">{displayDate}</span>
              </OverlayTrigger>
            )}
          </>
        );
      },
      sortable: true,
      reorder: true,
      width: "300px",
      conditionalCellStyles: [
        {
          when: (row) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dateFrom = new Date(row.dateFrom);
            dateFrom.setHours(0, 0, 0, 0);
            const dateTo = new Date(row.dateTo);
            dateTo.setHours(0, 0, 0, 0);
            return dateFrom >= today || dateTo >= today;
          },
          style: { backgroundColor: "#e7f6ea" },
        },
      ],
    },
    {
      id: "Retreatants",
      name: "# Retreatant Couples",
      selector: (row) => row && row.countRetreatant,
      cell: (row) => (
        <div className="tooltip-static-demo">
          <div
            className="bs-tooltip-bottom bs-tooltip-bottom-demo tooltip-info"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
          >
            <div className="arrow"></div>
            <a
              href={`/retreatRoster?retreatId=${row.id}&flag=1`}
              style={{ textDecoration: "none" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="tooltip-inner">{row && row.countRetreatant}</div>
            </a>
          </div>
        </div>
      ),
      reorder: true,
      sortable: true,
      width: "200px",
      style: { cursor: "text" },
      conditionalCellStyles: [
        {
          when: (row) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dateFrom = new Date(row.dateFrom);
            dateFrom.setHours(0, 0, 0, 0);
            const dateTo = new Date(row.dateTo);
            dateTo.setHours(0, 0, 0, 0);
            return dateFrom >= today || dateTo >= today;
          },
          style: { backgroundColor: "#e7f6ea" },
        },
      ],
    },
    {
      id: "team",
      name: "# Team Couples",
      selector: (row) => row && row.countTeam,
      cell: (row) => (
        <div className="tooltip-static-demo">
          <div
            className="bs-tooltip-bottom bs-tooltip-bottom-demo tooltip-info"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
          >
            <div className="arrow"></div>
            <a
              href={`/retreatRoster?retreatId=${row.id}&flag=2`}
              style={{ textDecoration: "none" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="tooltip-inner">{row && row.countTeam}</div>
            </a>
          </div>
        </div>
      ),
      reorder: true,
      sortable: true,
      width: "170px",
      style: { cursor: "text" },
      conditionalCellStyles: [
        {
          when: (row) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dateFrom = new Date(row.dateFrom);
            dateFrom.setHours(0, 0, 0, 0);
            const dateTo = new Date(row.dateTo);
            dateTo.setHours(0, 0, 0, 0);
            return dateFrom >= today || dateTo >= today;
          },
          style: { backgroundColor: "#e7f6ea" },
        },
      ],
    },

    {
      id: "Post Retreat Closure",
      name: "Post Retreat Closure",
      cell: (row) => {
        const rosterOk =
          row?.confirmation?.[0] && row.confirmation[0].roasterData == true;
        const directoryOk =
          row?.confirmation?.[1] && row.confirmation[1].Directory == true;
        const programOk =
          row?.confirmation?.[2] && row.confirmation[2].Program == true;
        const Item = ({ ok, label, href, title }) => {
          const body = (
            <>
              <span className={ok ? "mr-dot mr-dot-ok" : "mr-dot mr-dot-open"} />
              <span>{label}</span>
            </>
          );
          if (ok && href) {
            return (
              <a
                className="mr-closure-item"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                title={title}
              >
                {body}
              </a>
            );
          }
          return (
            <div className="mr-closure-item" title={title}>
              {body}
            </div>
          );
        };
        return (
          <div className="mr-closure">
            <Item ok={rosterOk} label="Roster" title="Retreat roster data" />
            <Item
              ok={directoryOk}
              label="Directory"
              href={`/directory/${row.id}`}
              title="Directory"
            />
            <Item
              ok={programOk}
              label="Program"
              href={`/program/${row.id}`}
              title="Program"
            />
          </div>
        );
      },
      sortable: true,
      reorder: true,
      width: "140px",
      style: { cursor: "text" },
      conditionalCellStyles: [
        {
          when: (row) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dateFrom = new Date(row.dateFrom);
            dateFrom.setHours(0, 0, 0, 0);
            const dateTo = new Date(row.dateTo);
            dateTo.setHours(0, 0, 0, 0);
            return dateFrom >= today || dateTo >= today;
          },
          style: { backgroundColor: "#e7f6ea" },
        },
      ],
    },
    {
      id: "language",
      name: "Language",
      selector: (row) =>
        row?.language?.charAt(0).toUpperCase() + row?.language?.slice(1),
      sortable: true,
      reorder: true,
      width: "120px",
      style: { cursor: "text" },
      conditionalCellStyles: [
        {
          when: (row) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dateFrom = new Date(row.dateFrom);
            dateFrom.setHours(0, 0, 0, 0);
            const dateTo = new Date(row.dateTo);
            dateTo.setHours(0, 0, 0, 0);
            return dateFrom >= today || dateTo >= today;
          },
          style: { backgroundColor: "#e7f6ea" },
        },
      ],
    },
    {
      id: "location",
      name: "Location",
      selector: (row) =>
        row?.location?.charAt(0).toUpperCase() + row?.location?.slice(1),
      sortable: true,
      reorder: true,
      width: "130px",
      style: { cursor: "text" },
      conditionalCellStyles: [
        {
          when: (row) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dateFrom = new Date(row.dateFrom);
            dateFrom.setHours(0, 0, 0, 0);
            const dateTo = new Date(row.dateTo);
            dateTo.setHours(0, 0, 0, 0);
            return dateFrom >= today || dateTo >= today;
          },
          style: { backgroundColor: "#e7f6ea" },
        },
      ],
    },
    {
      id: "fromToDate",
      name: "Retreat Dates",
      cell: (row) => {
        const formatDateRange = (from, to) => {
          if (moment(from).isSame(to, "day")) {
            return `${moment(from).tz("America/New_York").format("MMM D, YYYY")}`;
          } else if (moment(from).isSame(to, "month")) {
            return `${moment(from).tz("America/New_York").format("MMM D")} - ${moment(to).tz("America/New_York").format("D")}, ${moment(from).tz("America/New_York").format("YYYY")}`;
          } else {
            return `${moment(from).tz("America/New_York").format("MMM D")} - ${moment(to).tz("America/New_York").format("MMM D")}, ${moment(from).tz("America/New_York").format("YYYY")}`;
          }
        };
        const displayDate =
          row.dateFrom && row.dateTo
            ? formatDateRange(row.dateFrom, row.dateTo)
            : null;
        return (
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip(displayDate)}
          >
            <span>{displayDate}</span>
          </OverlayTrigger>
        );
      },
      sortable: true,
      reorder: true,
      width: "140px",
      style: { cursor: "text" },
      conditionalCellStyles: [
        {
          when: (row) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dateFrom = new Date(row.dateFrom);
            dateFrom.setHours(0, 0, 0, 0);
            const dateTo = new Date(row.dateTo);
            dateTo.setHours(0, 0, 0, 0);
            return dateFrom >= today || dateTo >= today;
          },
          style: { backgroundColor: "#e7f6ea" },
        },
      ],
    },

    {
      id: "Directory",
      name: "Directory",
      button: true,
      ignoreRowClick: true,
      allowOverflow: true,
      cell: (row) =>
        renderFileActions(row, {
          fileUrl: row.directoryFile,
          onUpload: handleUploadDirectory,
          uploadTitle: "Upload Directory",
          viewTitle: "View Directory",
          iconClass: "mdi-folder-open",
        }),
      reorder: true,
      width: "110px",
      conditionalCellStyles: [
        {
          when: (row) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dateFrom = new Date(row.dateFrom);
            dateFrom.setHours(0, 0, 0, 0);
            const dateTo = new Date(row.dateTo);
            dateTo.setHours(0, 0, 0, 0);
            return dateFrom >= today || dateTo >= today;
          },
          style: { backgroundColor: "#e7f6ea" },
        },
      ],
    },
    {
      id: "Program",
      name: "Program",
      button: true,
      ignoreRowClick: true,
      allowOverflow: true,
      cell: (row) =>
        renderFileActions(row, {
          fileUrl: row.programFile,
          onUpload: handleUploadProgram,
          uploadTitle: "Upload Program",
          viewTitle: "View Program",
          iconClass: "mdi-calendar-multiselect",
        }),
      reorder: true,
      width: "110px",
      conditionalCellStyles: [
        {
          when: (row) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dateFrom = new Date(row.dateFrom);
            dateFrom.setHours(0, 0, 0, 0);
            const dateTo = new Date(row.dateTo);
            dateTo.setHours(0, 0, 0, 0);
            return dateFrom >= today || dateTo >= today;
          },
          style: { backgroundColor: "#e7f6ea" },
        },
      ],
    },
    {
      id: "created",
      name: "Created",
      selector: (row) =>
        Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY hh:mm:a"),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY hh:mm:a"),
          )}
        >
          <span>
            {Helpers.convertUtcToTimezone(
              row && row.createdAt,
              "MM-DD-YYYY hh:mm:a",
            )}
          </span>
        </OverlayTrigger>
      ),
      reorder: true,
      sortable: true,
      width: "170px",
      style: { cursor: "text" },
      conditionalCellStyles: [
        {
          when: (row) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dateFrom = new Date(row.dateFrom);
            dateFrom.setHours(0, 0, 0, 0);
            const dateTo = new Date(row.dateTo);
            dateTo.setHours(0, 0, 0, 0);
            return dateFrom >= today || dateTo >= today;
          },
          style: { backgroundColor: "#e7f6ea" },
        },
      ],
    },
    {
      id: "created_by",
      name: "Created By",
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            row.contact_name &&
              row.contact_name !== "" &&
              row.contact_name !== null
              ? row.contact_name
              : "ADMIN",
          )}
        >
          {row.contact_name &&
          row.contact_name !== "" &&
          row.contact_name !== null ? (
            <span
              onClick={() => {
                setContactData(true);
                setRetreatDetail(row);
              }}
              className="sampleData"
            >
              {row.contact_name}
            </span>
          ) : (
            <span>ADMIN</span>
          )}
        </OverlayTrigger>
      ),
      reorder: true,
      sortable: true,
      width: "130px",
      conditionalCellStyles: [
        {
          when: (row) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dateFrom = new Date(row.dateFrom);
            dateFrom.setHours(0, 0, 0, 0);
            const dateTo = new Date(row.dateTo);
            dateTo.setHours(0, 0, 0, 0);
            return dateFrom >= today || dateTo >= today;
          },
          style: { backgroundColor: "#e7f6ea" },
        },
      ],
      style: { cursor: "text" },
    },
    {
      id: "confirmed_by",
      name: "Confirmed By",
      center: true,
      cell: (row) => (
        <div className="mr-confirmed-wrap">
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip("Who confirmed this Retreat")}
          >
            <span
              className="mr-confirmed-by"
              onClick={() => {
                setConfirmedData(true);
                setRetreatDetail(row);
              }}
            >
              <i
                className="mdi mdi-view-headline font-size action-icons"
                title="Confirmed List"
              ></i>
            </span>
          </OverlayTrigger>
        </div>
      ),
      reorder: true,
      sortable: true,
      width: "150px",
      style: { cursor: "pointer" },
      conditionalCellStyles: [
        {
          when: (row) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dateFrom = new Date(row.dateFrom);
            dateFrom.setHours(0, 0, 0, 0);
            const dateTo = new Date(row.dateTo);
            dateTo.setHours(0, 0, 0, 0);
            return dateFrom >= today || dateTo >= today;
          },
          style: { backgroundColor: "#e7f6ea" },
        },
      ],
    },
    ...(userData && userData.userRole !== "ADMIN" && userData.access === true
      ? [
          {
            id: "action",
            name: "Retreat Admins",
            button: true,
            cell: (row) => (
              <a className="font-size action-icons">
                <i
                  type="button"
                  onClick={() => subAdminPopUP(row)}
                  className="mdi mdi-plus-circle btn-icon-prepend plus-icon-role"
                  style={{
                    fontSize: "1.5rem",
                    cursor: "pointer",
                  }}
                  title="Add Retreat Administrators"
                ></i>
              </a>
            ),
            reorder: true,
            width: "150px",
            conditionalCellStyles: [
              {
                when: (row) => {
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  const dateFrom = new Date(row.dateFrom);
                  dateFrom.setHours(0, 0, 0, 0);
                  const dateTo = new Date(row.dateTo);
                  dateTo.setHours(0, 0, 0, 0);
                  return dateFrom >= today || dateTo >= today;
                },
                style: { backgroundColor: "#e7f6ea" },
              },
            ],
          },
        ]
      : []),
  ];

  const handleShow = (item) => {
    setRetreatDetail(item);
    setShow(true);
    setIcon_id(item.id);
    let d = { ...data };
    d.id = item.id;
    d.title = item.title;
    d.language = item.language;
    d.location = item.location;
    d.parishName = item.parishName;
    setData(d);
  };

  const handleClose = () => {
    if (showingRetreats === true) {
      getAllRetreats(1, 20, null, {}, false, "", userData?.id);
    } else {
      getAllRetreats();
    }
    setShow(false);
  };

  const renderModel = () => {
    return (
      <Modal
        show={showRegModal}
        onHide={() => {
          setShowREgModal(false);
          setDirectory([]);
          setProgram([]);
          if (showingRetreats === true) {
            getAllRetreats(1, 20, null, {}, false, "", userData?.id);
          } else {
            getAllRetreats();
          }
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Retreat BackUp</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ListGroup>
            {deleteList &&
              deleteList.map((item, i) => (
                <ListGroup.Item key={i} className="d-flex restore-delete">
                  <div>
                    <a
                      href=""
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(`/retreatRoster?retreatId=${item.id}`);
                      }}
                    >
                      <div>{item.title}</div>
                    </a>
                    {item.dateFrom === item.dateTo ? (
                      <span>
                        {moment(item && item.dateFrom)
                          .tz("America/New_York")
                          .format("MMM-DD-YYYY")}
                      </span>
                    ) : (
                      <span>
                        {moment(item && item.dateFrom)
                          .tz("America/New_York")
                          .format("MMM-DD") +
                          " - " +
                          moment(item.dateTo)
                            .tz("America/New_York")
                            .format("MMM DD") +
                          ", " +
                          moment(item && item.dateFrom)
                            .tz("America/New_York")
                            .format("YYYY")}
                      </span>
                    )}
                  </div>
                  <div>
                    {" "}
                    <button
                      className="font-size button-33"
                      onClick={() => restoreRetreat(item.id)}
                    >
                      Restore
                    </button>
                    <button
                      className="font-size button-35"
                      onClick={() => permanentDeleteRetreat(item.id)}
                    >
                      Delete
                    </button>
                  </div>
                </ListGroup.Item>
              ))}
          </ListGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowREgModal(false);
              if (showingRetreats === true) {
                getAllRetreats(1, 20, null, {}, false, "", userData?.id);
              } else {
                getAllRetreats();
              }
              setDirectory([]);
              setProgram([]);
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const handleCloseAlert = () => {
    setContactData(false);
    setConfirmedData(false);
  };

  const handleClick = () => {
    setParishValue("");
    if (!showingRetreats) {
      getAllRetreats(1, 20, null, {}, false, "", userData?.id);
    } else {
      getAllRetreats();
    }
    setShowingRetreats(!showingRetreats);
  };

  const getSelectedRetreatData = async () => {
    setLoadData(true);
    try {
      let res;
      const isAllSelectedNoFilters =
        allSelected &&
        (parishValue === "" || parishValue === null) &&
        (searchKey === "" || searchKey === null) &&
        !languageFilterRef.current;

      const isAllSelectedWithFilters =
        allSelected &&
        (parishValue !== "" || searchKey !== "" || languageFilterRef.current);

      const isSpecificSelection = !allSelected && selectedRetreats.length > 0;

      if (isAllSelectedNoFilters) {
        res = await retreatApi.getAllRetreatData();
      } else if (isAllSelectedWithFilters) {
        res = await retreatApi.getAllRetreats({
          pageNo: 1,
          size: 10000,
          searchKeyword: searchKey,
          parishValue: parishValue,
          languageFilter: languageFilterRef.current || null,
          allRetreat: true,
        });

        if (res.success) {
          const retreatIds = res.data.map((retreat) => retreat.id);
          res = await retreatApi.getSelectedRetreatData({
            retreats: retreatIds,
          });
        }
      } else if (isSpecificSelection) {
        res = await retreatApi.getSelectedRetreatData({
          retreats: selectedRetreats,
        });
      } else {
        toast.error("Please select at least one retreat to export");
        setLoadData(false);
        return;
      }

      if (!res.success) {
        toast.error(res.msg);
        setLoadData(false);
        return;
      }

      const allRetreatsData = res.data;

      const groupedData = allRetreatsData.reduce((acc, entry) => {
        const id = entry.retreatId;
        if (!acc[id]) acc[id] = [];
        acc[id].push(entry);
        return acc;
      }, {});

      const workbook = new ExcelJS.Workbook();
      const headers = [
        "Retreat Title",
        "Date From",
        "Date To",
        "Couple Id",
        "Type",
        "Image",
        "His Last Name",
        "His First Name",
        "Her Last Name",
        "Her First Name",
        "His Email",
        "Her Email",
        "His Mobile",
        "Her Mobile",
        "Service Role",
        "Service Title",
        "Talk",
        "Address",
        "City",
        "State",
        "Zip",
        "Parish",
        "Anniversary Date",
        "Dietary Restrictions Or Physical Limitations",
        "Under Age 35",
        "Emergency Name1",
        "Emergency Relationship1",
        "Emergency Phone1",
        "Emergency Name2",
        "Emergency Relationship2",
        "Emergency Phone2",
        "Referral from a friend/family member",
        "Notes",
      ];

      const missingText = "⚠ This is Missing";
      Object.entries(groupedData).forEach(([retreatId, couples], index) => {
        let baseTitle = couples[0]?.title || `Retreat-${retreatId}`;
        baseTitle = baseTitle.replace(/[\\/*?:[\]]/g, "");
        let sheetTitle = `${index + 1}_` + baseTitle.slice(0, 25);
        if (sheetTitle.length > 31) sheetTitle = sheetTitle.slice(0, 31);

        const worksheet = workbook.addWorksheet(sheetTitle);
        worksheet.addRow(headers);

        couples.forEach((item) => {
          const rowData = [
            item.title || missingText,
            moment(item?.dateFrom)
              .tz("America/New_York")
              .format("MMM-DD-YYYY") || missingText,
            moment(item?.dateTo).tz("America/New_York").format("MMM-DD-YYYY") ||
              missingText,
            item.primaryKey || missingText,
            item.attendeeType || missingText,
            item.imageUrl || missingText,
            item.hisLastName || missingText,
            item.hisFirstName || missingText,
            item.herLastName || missingText,
            item.herFirstName || missingText,
            item.hisEmail || missingText,
            item.herEmail || missingText,
            item.hisMobile || missingText,
            item.herMobile || missingText,
            item.role || "⚠ No Role",
            item.service || "⚠ No Service",
            item.talk || "⚠ No Talk",
            item.address || missingText,
            item.city || missingText,
            item.state || missingText,
            item.zip || missingText,
            item.coupleParish || missingText,
            item.anniversary_date
              ? Helpers.convertUtcToTimezone(item.anniversary_date, "M/D/YYYY")
              : missingText,
            item.allergies || missingText,
            item.under_age_35 || missingText,
            item.emergency_name1 || missingText,
            item.emergency_relationship1 || missingText,
            item.emergency_phone1 || missingText,
            item.emergency_name2 || missingText,
            item.emergency_relationship2 || missingText,
            item.emergency_phone2 || missingText,
            item.referral_from_a_friend_or_family_member || missingText,
            item.notes || missingText,
          ];

          const row = worksheet.addRow(rowData);
          for (let i = 1; i <= rowData.length; i++) {
            const cell = row.getCell(i);
            if (cell.value === missingText) {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFF00" },
              };
            }
          }
        });

        worksheet.columns.forEach((column) => {
          let maxLength = 0;
          column.eachCell({ includeEmpty: true }, (cell) => {
            const val = cell.value ? cell.value.toString() : "";
            maxLength = Math.max(maxLength, val.length);
          });
          column.width = maxLength + 2;
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Retreats_Export.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
      setLoadData(false);
    } catch (error) {
      console.error("error--->", error);
      toast.error("Failed to fetch data");
      setLoadData(false);
    }
  };

  const onSelectedParishRetreat = (e) => {
    setParishValue(e.target.value);
    const selectedParishId = e.target.value ? parseInt(e.target.value, 10) : null;
    if (showingRetreats === true) {
      getAllRetreats(
        1,
        20,
        null,
        {},
        false,
        "",
        userData?.id,
        selectedParishId,
      );
    } else {
      getAllRetreats(1, 20, null, {}, false, "", null, selectedParishId);
    }
  };

  const syncLanguageUrl = (nextLanguage) => {
    const params = new URLSearchParams(locationData.search);
    if (nextLanguage) params.set("language", nextLanguage);
    else params.delete("language");
    const search = params.toString();
    navigate(
      { pathname: "/manageRetreat", search: search ? `?${search}` : "" },
      { replace: true, state: locationData.state },
    );
  };

  const onSelectedLanguageRetreat = (e) => {
    const nextLanguage = e.target.value;
    languageFilterRef.current = nextLanguage;
    setLanguageFilter(nextLanguage);
    syncLanguageUrl(nextLanguage);
    const activeParish = parishValue || locationData?.state?.parishValue || null;
    if (showingRetreats === true) {
      getAllRetreats(1, 20, searchKey || null, {}, false, "", userData?.id, activeParish);
    } else {
      getAllRetreats(1, 20, searchKey || null, {}, false, "", null, activeParish);
    }
  };

  const isAdmin = userData && userData.userRole === "ADMIN";
  const selectedLabel = allSelected
    ? "All matching retreats selected"
    : selectedRetreats.length > 0
      ? `${selectedRetreats.length} selected`
      : "Select rows to export";

  return (
    <div className="mr-page">
      <header className="mr-header">
        <div className="mr-header-copy">
          <p className="mr-kicker">Retreat management</p>
          <div className="mr-title-row">
            <h1 className="mr-title">Retreats</h1>
            <span className="mr-count">{total || 0}</span>
          </div>
        </div>
        <div className="mr-header-actions">
          <button
            type="button"
            className="mr-btn mr-btn-ghost"
            onClick={() => training?.openGuide("create-edit-retreat")}
          >
            <i className="mdi mdi-play-circle-outline" aria-hidden="true" />
            Watch Guide
          </button>
          {isAdmin && userData?.committeeMember === true ? (
            <button
              type="button"
              className={`mr-btn mr-btn-ghost${showingRetreats ? " is-active" : ""}`}
              onClick={handleClick}
            >
              {showingRetreats ? "All retreats" : "My retreats"}
            </button>
          ) : null}
          {isAdmin ? (
            <>
              <a className="mr-btn mr-btn-ghost" href="/retreat-backup">
                Retreat Backups
              </a>
              <button
                type="button"
                className="mr-btn mr-btn-ghost"
                onClick={() => setShowPasswordMailModal(true)}
              >
                Send Registration Password
              </button>
              <Link
                to="/create-retreat"
                className="mr-btn mr-btn-primary"
                onClick={clearfield}
              >
                <i className="mdi mdi-plus" />
                Add Retreat
              </Link>
            </>
          ) : null}
        </div>
      </header>

      <div className="mr-toolbar">
        {isAdmin ? (
          <label className="mr-field mr-field-search">
            <i className="mdi mdi-magnify" aria-hidden="true" />
            <input
              onChange={SearchData}
              value={searchKey}
              type="search"
              placeholder="Search parish, language, or location"
              aria-label="Search retreats"
            />
          </label>
        ) : null}
        <label className={`mr-field mr-field-language${languageFilter ? " is-active" : ""}`}>
          <i className="mdi mdi-translate" aria-hidden="true" />
          <select
            onChange={onSelectedLanguageRetreat}
            value={
              LANGUAGE_FILTER_OPTIONS.some((item) => item.value === languageFilter)
                ? languageFilter
                : ""
            }
            aria-label="Filter by language"
          >
            {LANGUAGE_FILTER_OPTIONS.map((item) => (
              <option key={item.value || "all"} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </label>
        {isAdmin ? (
          <>
            <label className="mr-field mr-field-parish">
              <span>Parish</span>
              <select
                onChange={onSelectedParishRetreat}
                value={parishValue}
                aria-label="Filter by parish"
              >
                <option value="">All Parishes</option>
                {perishDataList.map((item) => (
                  <option key={item.id} value={item.id}>
                    {formatParishOptionLabel(item)}
                  </option>
                ))}
              </select>
            </label>
            <button
              type="button"
              className="mr-btn mr-btn-ghost"
              onClick={() => {
                setSelectedRetreats([]);
                setAllSelected(false);
                setParishValue("");
                setSearchKey("");
                languageFilterRef.current = "";
                setLanguageFilter("");
                syncLanguageUrl("");
                setClearSelectionTrigger((prev) => !prev);
                if (showingRetreats === true) {
                  getAllRetreats(1, 20, "", {}, false, "", userData?.id);
                } else {
                  getAllRetreats(1, 20, "");
                }
              }}
            >
              View all
            </button>
          </>
        ) : null}
        <div className="mr-toolbar-meta">
          <span
            className={`mr-selection${
              selectedRetreats.length || allSelected ? "" : " mr-selection-hint"
            }`}
          >
            {selectedLabel}
          </span>
          <button
            type="button"
            className="mr-btn mr-btn-export"
            onClick={getSelectedRetreatData}
          >
            <i className="mdi mdi-download" />
            Export Retreat Data
          </button>
        </div>
      </div>

      <section className="mr-table-card" aria-label="Retreat list">
        <CustomDataTable
          key={`retreats-${languageFilter}-${parishValue || ""}`}
          loading={LoadData}
          data={allRetreatData}
          countPerPage={20}
          isServerSide={true}
          pagination={true}
          sortServer={true}
          total={total}
          columns={columns}
          dataFetchApi={getAllRetreats}
          pointerOnHover={true}
          highlightOnHover={true}
          committeeId={showingRetreats ? userData?.id : null}
          parishValue={parishValue || locationData?.state?.parishValue}
          selectableRows
          clearSelectedRows={clearSelectionTrigger}
          noDataComponent={
            <div className="mr-empty">
              <p>No retreats to show</p>
              <span>Try another language or parish, clear the search, or add a retreat.</span>
            </div>
          }
          onSelectedRowsChange={(state) => {
            const { selectedRows, allSelected } = state;
            if (allSelected) {
              setAllSelected(true);
            } else {
              setAllSelected(false);
            }
            setSelectedRetreats(selectedRows.map((row) => row.id));
          }}
        />
      </section>

      {showRegModal ? renderModel() : null}
      {show ? (
        <DeleteModel
          show={show}
          handleClose={handleClose}
          DeleteData={deleteRetreat}
          title={retreatDetail.title}
          selectionDelete="temporary"
        ></DeleteModel>
      ) : null}
      {contactData ? (
        <AlertDelete
          show={contactData}
          alertHeader="Contact Information"
          alerMessage={
            <div>
              <div>
                <h5 className="mt-4">
                  <strong>Contact Name :</strong> {retreatDetail.contact_name}
                </h5>
                <h5 className="mt-4">
                  <strong>Contact Email :</strong> {retreatDetail.contact_email}
                </h5>
                <h5 className="mt-4">
                  <strong>Contact Mobile :</strong>{" "}
                  {retreatDetail.contact_mobile}
                </h5>
              </div>
            </div>
          }
          handleClose={handleCloseAlert}
          buttonText={"Close"}
        />
      ) : null}

      {confirmedData ? (
        <ConfirmationAuditModal
          show={confirmedData}
          retreat={retreatDetail}
          onClose={handleCloseAlert}
        />
      ) : null}

      {/* File Upload Modal */}
      <FileUploadModal
        show={showUploadModal}
        handleClose={handleUploadModalClose}
        rowId={selectedRowId}
        handleUploadSuccess={handleUploadSuccess}
        fileType={fileType}
        onDeleteFile={handleDeleteFile}
        existingFileUrl={existingFileUrl}
        modalTitle={uploadModalTitle}
        userData={userData}
      />
      {showFreeze ? (
        <AlertModal
          show={showFreeze}
          handleClose={handleClose2}
          message={`Are you sure you want to ${
            alertData.value === "FREEZE" ? "UNFREEZE" : "FREEZE"
          } this retreat?`}
          actionFunction={retreatFreeze}
          cancel={"Cancel"}
          okay={"Okay"}
          heading={"ALERT!!"}
        />
      ) : null}

      {/* ── Confirm removal of a Retreat Administrator ── */}
      {removeAccessModal ? (
        <DeleteModel
          show={removeAccessModal}
          content={
            <>
              <h5 className="mt-4 fw-bold">Remove Retreat Administrator</h5>
              <div className="p-3 border rounded-3 bg-light shadow-sm">
                <div className="mb-2">
                  <span className="fw-bold">Administrator:</span>{" "}
                  <span className="text-muted">{editIndex}</span>
                </div>
              </div>
            </>
          }
          handleClose={handleAccessRmvClose}
          DeleteData={removeAccessFromRetreat}
        />
      ) : null}

      {/* ── "Add Retreat Administrators" modal — same as CreateRetreat.jsx ── */}
      {createRetAdmin ? (
        <CreateRetreatSubAdmin
          show={createRetAdmin}
          alertHeader={"Add Retreat Administrators"}
          alerMessage={""}
          allCoupleMails={allCoupleMails}
          allCoupleData={allCoupleData}
          ediUserIdClicked={ediUserIdClicked}
          data={data}
          handlerAccessRmvShow={handlerAccessRmvShow}
          editRetreat={editRetreat}
          getAllCouples={getAllCouples}
          handleClose={() => {
            setCreateRetAdmin(false);
            setEdiUserIdClicked("");
            // Refresh the table so updated userEmails are reflected
            if (showingRetreats === true) {
              getAllRetreats(1, 20, null, {}, false, "", userData?.id);
            } else {
              getAllRetreats();
            }
          }}
        ></CreateRetreatSubAdmin>
      ) : null}

      <RetreatStatusModal
        show={showStatus}
        onHide={handleCloseStatus}
        alertData={alertData}
        editBox={editBox}
        onConfirm={retreatChangeStatus}
      />
      {/* REGISTRATION PASSWORD MODAL */}
      <RegistrationPasswordSendModal
        show={showPasswordMailModal}
        onHide={() => setShowPasswordMailModal(false)}
        password={password}
      />

      {/* END REGISTRATION PASSWORD MODAL */}
    </div>
  );
};
export default ManageRetreat;
